import React from 'react';
import i18next from 'i18next';
import { DateFormatter } from 'components/AppTable/CellsComponents';

const getTableConfig = () => [
  {
    title: i18next.t('tablesLabels.studentId'),
    field: 'ids',
    Component: value => value || i18next.t('courseDetails.notSpecified'),
  },
  {
    title: i18next.t('tablesLabels.name'),
    field: 'fullName',
    isSorting: true,
  },
  {
    title: i18next.t('tablesLabels.trainingModule'),
    field: 'trainingModule',
  },
  {
    title: i18next.t('tablesLabels.trainingPart'),
    field: 'trainingPart',
  },
  {
    title: i18next.t('tablesLabels.expiryDate'),
    field: 'expirationDate',
    Component: value =>
      value === null || value === undefined ? (
        i18next.t('trainingSessions.incomplete')
      ) : (
        <DateFormatter value={value} />
      ),
    isSorting: true,
  },
  {
    title: '',
    field: 'id',
    isVisible: false,
  },
];

export default getTableConfig;
